<template>
  <div class="cp-option-row">
    <div class="cp-field cp-field--optvalue">
      <CustomInput :label="L.optionValue || 'Value'" :value="option.value" @input="update('value', $event)" />
    </div>
    <div class="cp-field cp-field--optlabel">
      <CustomInput :label="L.optionLabel || 'Label'" :value="option.labels[lang]" @input="updateLabel($event)" />
    </div>
    <md-button class="md-icon-button cp-option-remove" :title="L.remove || 'Remove'" @click="$emit('remove')">
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>

<script>
import CustomInput from '../../../parts/CustomInput.vue'

/**
 * One choice option for a 'choices' question: a stored value + a per-language label.
 * Mutates the shared option object in place (value + labels[lang]).
 */
export default {
  name: 'OptionRow',
  components: { CustomInput },
  props: {
    options: { type: Object, required: true },   // global Lang holder
    option: { type: Object, required: true },     // { value, labels:{lang} }
    lang: { type: String, default: 'de' }
  },
  computed: {
    L() { return this.options.Lang || {}; }
  },
  methods: {
    update(key, val) { this.option[key] = val; },
    updateLabel(val) { this.$set(this.option.labels, this.lang, val); }
  }
};
</script>

<style scoped>
.cp-option-row { display: flex; align-items: flex-end; gap: 0.6rem; margin-bottom: 0.6rem; flex-wrap: wrap; }
.cp-field { display: flex; flex-direction: column; min-width: 0; }
.cp-field--optvalue { width: 150px; }
.cp-field--optlabel { flex: 1; min-width: 140px; }
.cp-option-remove .md-icon { color: #d9534f; }
.cp-label { display: block; font-size: 0.78rem; font-weight: 600; color: #555; margin-bottom: 0.25rem; }
</style>
